import { MessageBox } from 'element-ui'
const messageBox = (options) => {
  const option = options || {}
  const confirmClass =
    option.type === 'error'
      ? 'btn btn--alert'
      : option.type === 'success'
      ? 'btn btn--primary'
      : 'btn btn--primary'
  option.customClass = option.customClass
    ? `message-box ${option.customClass}`
    : 'message-box'
  option.type === 'error' &&
    (option.iconClass = 'el-icon-warning-outline error')
  option.type === 'warning' &&
    (option.iconClass = 'el-icon-warning-outline warning')
  MessageBox({
    type: 'error',
    autofocus: false,
    showClose: false,
    message: ' ',
    showCancelButton: option.type === 'success' ? false : true,
    cancelButtonText: '取消',
    cancelButtonClass: 'btn btn-bordered--default',
    confirmButtonText: '確定',
    confirmButtonClass: confirmClass,
    ...option
  }).catch(() => {})
}

export default messageBox
